import { gql } from "@apollo/client";

export const GET_PROFILE = gql`
  query GetRunnerProfile($userId: ID!) {
    getRunnerProfile(userId: $userId) {
      user {
        firstName
        nickName
        rol
        urlImg
        membership
        membershipStatus
        dateBirth
      }
      answers {
        general {
          altura
          peso
        }
        preferencias {
          horario
          terreno
          distancia
        }
      }
      rutasCompletas
      totalKm
    }
  }
`;
